import { useTranslate } from 'src/localization/Trns'

import { PhysicalCardManagementStatus } from './cardDetailHeroDemoData'

/**
 * Single source of truth for a card status's display label, so the summary pill
 * and the card-art accessible name never disagree on wording.
 *
 * The literal keys stay inside `translate()` so the localization extractor can
 * see them — a lookup table keyed by status would defeat it, which is why this
 * is a hook returning a mapper rather than a plain object.
 */
export const useCardStatusLabel = (): ((
  status: PhysicalCardManagementStatus,
) => string) => {
  const translate = useTranslate()

  return (status) => {
    switch (status) {
      case 'ACTIVE':
        return translate('Active')
      case 'PENDING_ISSUANCE':
        return translate('Pending issuance')
      case 'FROZEN':
        return translate('Frozen')
      case 'LOCKED':
        // "Locked by Admin" (not bare "Locked") to match the design and the
        // card-art overlay — issuer/admin-imposed, never a voluntary freeze.
        return translate('Locked by Admin')
      case 'CANCELED':
        return translate('Cancelled')
      case 'FAILED':
        return translate('Failed')
    }
  }
}
